import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessUnitCompanyInformationModel } from '../business-unit-company-information.model';
import { ObjectTitleService } from '@fi-app/utilities/fi-services/object-title.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { BillingService } from '../../billing.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { AppTextService } from '@fi-shared/app-text';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { BillingContactUsingType } from '../../billing-contact-type';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';

@Component({
    selector: 'fi-billing-company-information-edit',
    templateUrl: './billing-company-information-edit.component.html',
    styleUrls: ['./billing-company-information-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-company-information-edit' },
    providers: [{ provide: FiComponentsContainer, useExisting: BillingCompanyInformationEditComponent }],
    standalone: false,
})
export class BillingCompanyInformationEditComponent extends FiComponentsContainer implements OnInit {
    @Input() businessUnitCompanyInformation: BusinessUnitCompanyInformationModel;

    editTabs: EditTabsModel;
    contactsUsingType = BillingContactUsingType.Contact;

    constructor(
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private stateService: FiStateService,
        private objectTitleService: ObjectTitleService,
    ) {
        super();
    }

    ngOnInit() {
        this.setPageHeaderData();
        this.saveChangesWarningService.start(() => this.businessUnitCompanyInformation);
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(
            this.objectTitleService.getEditTitle(this.appTextService.get('billing.company_information')),
        );
        this.editTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    save() {
        this.fiLoadingService
            .trackPromise(this.billingService.SaveBusinessUnitCompanyInformation(this.businessUnitCompanyInformation))
            .then(() => {
                this.saveChangesWarningService.stop();
                this.stateService.go(FiStateNames.Billing.CompanyInformation.List);
            });
    }
}
